/* widget-analytics.js  KAIDO Motors generic widget analytics helper.
 *
 * Exposes window.KAIDO.analytics = { trackEvent, getAnonymousId, getSessionId, getPageType }.
 * Transport: POST to log_widget_event edge function (CORS-gated, IP rate-limited, service-role insert).
 * Reuses existing globals window.SUPABASE_CONFIG + window.CURRENT_CUSTOMER_DATA from layout/theme.liquid.
 *
 * FR-7, FR-7a, FR-8, FR-9, FR-9a, FR-10, FR-10a, FR-11 (see PRD v3).
 */
(function () {
  var STORAGE_ANON = "kaido_anon_id";
  var STORAGE_SESSION = "kaido_session_id";
  var STORAGE_LAST_CUSTOMER = "kaido_last_seen_customer_id";
  var HEARTBEAT_KEY_PREFIX = "kaido_heartbeat_";
  var SUPABASE_URL =
    (window.SUPABASE_CONFIG && window.SUPABASE_CONFIG.url) ||
    "https://api.kaidomotors.com";
  var LOG_ENDPOINT = SUPABASE_URL + "/functions/v1/log_widget_event";

  function uuid() {
    try {
      if (window.crypto && typeof crypto.randomUUID === "function") {
        return crypto.randomUUID();
      }
      if (window.crypto && typeof crypto.getRandomValues === "function") {
        var b = new Uint8Array(16);
        crypto.getRandomValues(b);
        b[6] = (b[6] & 0x0f) | 0x40;
        b[8] = (b[8] & 0x3f) | 0x80;
        var hex = "";
        for (var i = 0; i < 16; i++) {
          var h = b[i].toString(16);
          hex += h.length === 1 ? "0" + h : h;
        }
        return (
          hex.slice(0, 8) +
          "-" +
          hex.slice(8, 12) +
          "-" +
          hex.slice(12, 16) +
          "-" +
          hex.slice(16, 20) +
          "-" +
          hex.slice(20)
        );
      }
    } catch (_) {}
    return (
      Date.now().toString(16) + "-" + Math.random().toString(36).slice(2, 10)
    );
  }

  function getAnonymousId() {
    try {
      var id = localStorage.getItem(STORAGE_ANON);
      if (!id) {
        id = uuid();
        localStorage.setItem(STORAGE_ANON, id);
      }
      return id;
    } catch (_) {
      return null;
    }
  }

  function getSessionId() {
    try {
      var id = sessionStorage.getItem(STORAGE_SESSION);
      if (!id) {
        id = uuid();
        sessionStorage.setItem(STORAGE_SESSION, id);
      }
      return id;
    } catch (_) {
      return null;
    }
  }

  function getPageType() {
    if (window.KAIDO && typeof window.KAIDO.pageType === "string" && window.KAIDO.pageType) {
      return window.KAIDO.pageType;
    }
    var p = window.location.pathname || "";
    if (p === "/" || p === "") return "index";
    if (p.indexOf("/products/") === 0) return "product";
    if (p.indexOf("/collections/") === 0) return "collection";
    if (p.indexOf("/cart") === 0) return "cart";
    if (p.indexOf("/checkout") === 0) return "checkout";
    if (p.indexOf("/account") === 0) return "customers/account";
    if (p.indexOf("/pages/reviews") === 0) return "page";
    if (p.indexOf("/blogs/") === 0) return "blog";
    if (p.indexOf("/policies/") === 0) return "policy";
    return "other";
  }

  function getCurrentShopifyId() {
    try {
      var v = window.CURRENT_CUSTOMER_DATA && window.CURRENT_CUSTOMER_DATA.id;
      if (v === undefined || v === null || v === "") return null;
      return String(v);
    } catch (_) {
      return null;
    }
  }

  /* FR-10a: strict null sentinel via removeItem  never empty-string. */
  function getLastSeenCustomerId() {
    try {
      var v = sessionStorage.getItem(STORAGE_LAST_CUSTOMER);
      if (v === null || v === "") return null;
      return v;
    } catch (_) {
      return null;
    }
  }

  function setLastSeenCustomerId(id) {
    try {
      if (id === null) sessionStorage.removeItem(STORAGE_LAST_CUSTOMER);
      else sessionStorage.setItem(STORAGE_LAST_CUSTOMER, id);
    } catch (_) {}
  }

  /* FR-10a transition matrix.
   *   From  To               Action
   *   null  null             no-op
   *   null  customer X       emit identity_linked (first_login). DO NOT rotate anon_id.
   *   X     X                no-op
   *   X     Y (different)    rotate anon_id, emit identity_linked (account_switch)
   *   X     null (logout)    rotate anon_id, NO identity_linked
   */
  function maybeRotateOnIdentityChange() {
    try {
      var currentId = getCurrentShopifyId();
      var last = getLastSeenCustomerId();
      if (last === currentId) return;

      if (last === null && currentId !== null) {
        var curAnon = getAnonymousId();
        _sendEvent("identity_linked", "system", {
          previous_anonymous_id: curAnon,
          current_anonymous_id: curAnon,
          link_reason: "first_login"
        });
      } else if (last !== null && currentId !== null && last !== currentId) {
        var oldAnon = getAnonymousId();
        var newAnon = uuid();
        try { localStorage.setItem(STORAGE_ANON, newAnon); } catch (_) {}
        _sendEvent("identity_linked", "system", {
          previous_anonymous_id: oldAnon,
          current_anonymous_id: newAnon,
          link_reason: "account_switch"
        });
      } else if (last !== null && currentId === null) {
        try { localStorage.setItem(STORAGE_ANON, uuid()); } catch (_) {}
      }

      setLastSeenCustomerId(currentId);
    } catch (_) {}
  }

  /* Consent / privacy gate.
   * Single opt-out signal set  ->  never transmit. Checked in priority order:
   *   1. Shopify Customer Privacy API (authoritative when present at runtime)
   *   2. Global Privacy Control (navigator.globalPrivacyControl === true)
   *   3. Do-Not-Track (navigator.doNotTrack / window.doNotTrack / msDoNotTrack)
   *   4. kaido-analytics-optout cookie or localStorage flag
   * Default when NONE of the above resolve to a "no": send (matches prior behavior).
   * Applied at the single send boundary (_sendEvent) so every event path is covered:
   * heartbeat, identity_linked, and all trackEvent() calls.
   */
  function _dntSet() {
    try {
      var dnt = navigator.doNotTrack || window.doNotTrack || navigator.msDoNotTrack;
      return dnt === "1" || dnt === "yes" || dnt === 1 || dnt === true;
    } catch (_) {
      return false;
    }
  }

  function _gpcSet() {
    try {
      return navigator.globalPrivacyControl === true;
    } catch (_) {
      return false;
    }
  }

  function _optedOut() {
    try {
      if (
        document.cookie &&
        document.cookie.indexOf("kaido-analytics-optout=1") !== -1
      ) {
        return true;
      }
    } catch (_) {}
    try {
      if (localStorage.getItem("kaido-analytics-optout") === "1") return true;
    } catch (_) {}
    return false;
  }

  function _trackingAllowed() {
    /* Hard opt-out signals  ->  NEVER send when any is set. */
    if (_gpcSet()) return false;
    if (_dntSet()) return false;
    if (_optedOut()) return false;

    /* Shopify Customer Privacy API is authoritative when available at runtime. */
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp) {
        if (
          typeof cp.analyticsProcessingAllowed === "function" &&
          cp.analyticsProcessingAllowed() === false
        ) {
          return false;
        }
        if (
          typeof cp.userCanBeTracked === "function" &&
          cp.userCanBeTracked() === false
        ) {
          return false;
        }
      }
    } catch (_) {}

    /* Consent undeterminable AND no GPC/DNT/opt-out  ->  default to send. */
    return true;
  }

  function _sendEvent(eventType, widgetType, payload) {
    try {
      /* Consent gate: bail before any network transmit if the visitor opted out. */
      if (!_trackingAllowed()) return;

      var elementId = payload && payload.elementId ? String(payload.elementId) : null;
      var md = {};
      if (payload && typeof payload === "object") {
        for (var k in payload) {
          if (Object.prototype.hasOwnProperty.call(payload, k) && k !== "elementId") {
            md[k] = payload[k];
          }
        }
      }
      md.schema_version = 1;
      md.client_ts = new Date().toISOString();

      var cid = getCurrentShopifyId();
      var row = {
        event_type: String(eventType).slice(0, 64),
        widget_type: String(widgetType).slice(0, 64),
        element_id: elementId,
        shopify_customer_id: cid ? cid.slice(0, 32) : null,
        customer_profile_id: null,
        anonymous_id: getAnonymousId(),
        session_id: getSessionId(),
        page_url: (window.location.origin + window.location.pathname).slice(0, 2000),
        page_type: (getPageType() || "").slice(0, 32),
        metadata: md,
        user_agent: (navigator.userAgent || "").slice(0, 500)
      };

      /* FR-9: fetch + keepalive. No apikey header  edge function is public + CORS-gated. */
      fetch(LOG_ENDPOINT, {
        method: "POST",
        keepalive: true,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(row)
      })
        .then(function (response) {
          if (!response || !response.ok) {
            /* FR-9a: never log err.message/stack/cause or raw error object. */
            try {
              console.warn(
                "[Kaido Analytics] transport failed:",
                eventType,
                widgetType,
                {
                  error: "http",
                  http_status: response ? response.status : null
                }
              );
            } catch (_) {}
          }
        })
        ["catch"](function (err) {
          try {
            console.warn(
              "[Kaido Analytics] transport failed:",
              eventType,
              widgetType,
              {
                error: (err && err.name) || "unknown",
                http_status: null
              }
            );
          } catch (_) {}
        });
    } catch (_) {
      /* silent  never throw from trackEvent */
    }
  }

  function trackEvent(eventType, widgetType, payload) {
    try {
      maybeRotateOnIdentityChange();
      /* FR-11: heartbeat once per session, session-scoped flag. */
      try {
        var sid = getSessionId();
        if (sid) {
          var hbKey = HEARTBEAT_KEY_PREFIX + sid;
          if (!sessionStorage.getItem(hbKey)) {
            sessionStorage.setItem(hbKey, "1");
            _sendEvent("heartbeat", "system", {});
          }
        }
      } catch (_) {}
      _sendEvent(eventType, widgetType, payload || {});
    } catch (_) {
      /* silent */
    }
  }

  window.KAIDO = window.KAIDO || {};
  window.KAIDO.analytics = {
    trackEvent: trackEvent,
    getAnonymousId: getAnonymousId,
    getSessionId: getSessionId,
    getPageType: getPageType
  };
})();
